import { render, staticRenderFns } from "./StudyResultDetailTable.vue?vue&type=template&id=4d08f2ae&scoped=true&lang=pug"
import script from "./StudyResultDetailTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultDetailTable.vue?vue&type=style&index=0&id=4d08f2ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08f2ae",
  null
  
)

export default component.exports